import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import menuToggle from "../../assets/images/icons/menuToggle.svg";
import ProtectedComponent from '../../permissions/ProtectedComponent';
import { permissions } from '../../permissions/roles';
import PermissionWrapper from "../../permission_advance/PermissionWrapper";
import { logout } from "../../helper/helper"
import moment from "moment";
import { useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import logOut from "../../assets/images/icons/logout.svg";
import AutoLogout from "./AutoLogout";
import { BASE_URL } from "../../env";

function HeaderMenu() {

  const [loginDate, setLoginDate] = useState('');
  // console.log("🚀 ~ HeaderMenu ~ login date:", loginDate)
  const [loginTime, setLoginTime] = useState('');

  // console.log("🚀 ~ HeaderMenu ~ loginTime:", loginTime)
  const localDate = moment().format("YYYY-MM-DD")
  const [localTime, setLocalTime] = useState(moment().format("hh:mm:ss A"));

  const [secondaryMenu, setSecondaryMenu] = useState(false);
  const [showLogoutPopup, setShowLogoutPopup] = useState(false);
  const [isSubmitButtonClicked, setIsSubmitButtonClicked] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setLocalTime(moment().format("hh:mm:ss A"));
    }, 1000); // update every second

    return () => clearInterval(timer); // cleanup on unmount
  }, []);

  // const localDate = "2025-05-31"
  const [error, setError] = useState('');

  useEffect(() => {
    const storedDateTime = localStorage.getItem("loginDateTime");

    if (!storedDateTime) {
      setError("No date found in localStorage");
      return;
    }

    try {
      // Clean the string (remove extra quotes/whitespace)
      const cleanedDateTime = storedDateTime.trim().replace(/^['"]|['"]$/g, '');

      // Parse with Moment.js (explicit ISO-8601 format)
      const momentObj = moment.utc(cleanedDateTime, moment.ISO_8601, true).local(); // strict mode

      if (!momentObj.isValid()) {
        throw new Error("Invalid date format");
      }

      // Format the date and time
      setLoginDate(momentObj.format('YYYY-MM-DD'));
      setLoginTime(momentObj.subtract(10, 'minutes').format('hh:mm:ss A'));

    } catch (err) {
      setError("Failed to parse date: " + err.message);
      console.error("Date parsing error:", err);
    }
  }, []); // Empty dependency array = runs once on mount

  const to24Hour = (timeStr) => {
    const [time, modifier] = timeStr.split(" ");
    let [hours, minutes, seconds] = time.split(":");

    hours = parseInt(hours, 10);

    if (modifier === "PM" && hours !== 12) {
      hours += 12;
    }
    if (modifier === "AM" && hours === 12) {
      hours = 0;
    }

    return hours * 3600 + parseInt(minutes) * 60 + parseInt(seconds);
  };

  useEffect(() => {
    if (loginDate !== "" && loginDate <= localDate) {

      const loginSeconds = to24Hour(loginTime);
      const localSeconds = to24Hour(localTime);

      const sevenAM = 7 * 3600;   // 07:00 AM
      const sevenPM = 19 * 3600;  // 07:00 PM

      if (
        loginSeconds < sevenAM &&
        localSeconds >= sevenAM &&
        localSeconds < sevenPM
      ) {
        ShowLogoutPopup();
      }
    }
  }, [loginDate, loginTime, localDate, localTime]);

  const ShowLogoutPopup = () => {
    setShowLogoutPopup(true);
    // Iterate through all keys in localStorage
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);

      // Check if the key contains the BASE_URL
      if (key && key.includes(BASE_URL)) {
        localStorage.removeItem(key);
      }
    }
    // Remove token specifically, if not covered by BASE_URL
    localStorage.removeItem("token");
    localStorage.removeItem("profileUserDetails");
    localStorage.removeItem("staffRoles");
    localStorage.removeItem("reduxState");
    localStorage.removeItem("userId");
    localStorage.removeItem("userLoggedInDetails");
    localStorage.removeItem("completeLoginDetail");
    localStorage.removeItem("loginDateTime");
    localStorage.removeItem("staffLevel");
    localStorage.removeItem("staffPermissionName");
    localStorage.removeItem("RotaTemplateSchedule");
    localStorage.clear();
  }
  const HideLogoutPopup = () => {
    logout();
    setTimeout(() => {
      setShowLogoutPopup(false);
    }, 2000);
  };
  const navigate = useNavigate();

  // useEffect(() => {
  //   const intervalId = setInterval(() => {
  //     const localTime = moment(); // current time

  //     const checkStart = moment("06:55:00", "HH:mm:ss");
  //     const checkEnd = moment("07:00:00", "HH:mm:ss");
  //     const popupStart = moment("06:59:30", "HH:mm:ss");
  //     const popupEnd = moment("07:00:00", "HH:mm:ss");

  //     const userLoggedInDetails = localStorage.getItem("userLoggedInDetails");
  //     const token = localStorage.getItem("token");
  //     const userId = localStorage.getItem("userId");
  //     const staffRoles = localStorage.getItem("staffRoles");

  //     // Check if within the active checking window (06:55 to 07:00)
  //     if (
  //       localTime.isBetween(checkStart, checkEnd, undefined, '[]') &&
  //       userLoggedInDetails && token && userId && staffRoles
  //     ) {
  //       // console.log("⏰ Checking time window… Current:", localTime.format("HH:mm:ss"));

  //       // Check if it's the restricted popup window (06:59:30 to 07:00)
  //       if (localTime.isBetween(popupStart, popupEnd, undefined, '[]')) {
  //         // console.log("⛔ Within restricted time — showing popup");
  //         ShowLogoutPopup();
  //       }
  //     }
  //   }, 5000); // check every 10 seconds

  //   return () => clearInterval(intervalId); // cleanup on unmount
  // }, []);

  // window.addEventListener("beforeunload", () => {
  //   try {
  //     logout();
  //   } catch (e) {
  //     console.error("Logout on close failed", e);
  //   }
  // });

  return (
    <>
      <AutoLogout logout={logout} />
      <IconButton
        className="secondaryMenuToggleIcon"
        color="inherit"
        onClick={() => {
          setSecondaryMenu(!secondaryMenu);
        }}
      >
        <img src={menuToggle} alt="sub menu" />
      </IconButton>
      <ul
        className={`headerMenu ${secondaryMenu ? "mobileSecondaryMenu" : ""}`}
      >

        <PermissionWrapper title="Super Admin" action="view">
          <li>
            <Link to="/settings">Settings</Link>
          </li>
          {/* <li>
            <Link to="/advanced">Advanced</Link>
          </li> */}
        </PermissionWrapper>
        <PermissionWrapper title="Staff" action="view">
          <li>
            <Link to="/staff-records">Staff Members</Link>
          </li>
        </PermissionWrapper>
        <li>
          <Link to="/service-users">Service Users</Link>
        </li>
      </ul>

      {/* Logout Screen Modal Popup */}
      <Modal
        show={showLogoutPopup}
        onHide={HideLogoutPopup}
        className="ftcModalPopup confirmationPopup deletionConfirmation"
      >
        <Modal.Header closeButton>
          <Modal.Title>Session Expired</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="editBlockContent text-center">
            <img src={logOut} alt="logout" className="lgoutButton" />
            <p>Your session has expired. Please log in again to continue. </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn-sm" variant="danger" onClick={logout}>
            Login
          </Button>
        </Modal.Footer>
      </Modal>

    </>
  );
}

export default HeaderMenu;
